'use client';

export { default } from './Snackbar';
export { default as snackbarClasses } from './snackbarClasses';
export * from './snackbarClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Snackbar/index.js
// module id = 879
// module chunks = 22